(ns ycweb.app.dashboard.planning.bulk
  (:require
   #?(:cljs [goog.labs.format.csv :as csv])
   [rum.core :as rum]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.dashboard.planning.common :as planning.cmn]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.flow :as flow]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn upload-valid?
  "A SKU column, one to four monthly quantities, and an optional Cost column."
  [rows header]
  (let [cost-column? (some #(re-find #"(?i)cost" (str %)) header)
        widths (map count rows)]
    (and
      (seq rows)
      (>= (apply min widths) 2)
      (<= (apply max widths) (if cost-column? 6 5)))))

(rum/defc file-upload < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        loaded-file (cmn/curact action-atom :file)

            file-valid? (upload-valid? loaded-file (cmn/curact action-atom :header))]

    [:div.form-field
     [:div.file-input-wrapper
      [:span.form-label "CSV File Upload:"]
      [:label
       {:class
        (u/bem :dope-file-input
          [(when (cmn/curact action-atom :loading) :is-uploading)])}
       [:input.dope-file-input__field
        {:type "file"
         :accept ".csv"
         :on-change
         (fn [x]
           #?(:clj x
              :cljs
              (let [fr (js/FileReader.)
                    first-file (when x (first (.-files (.getElementById js/document "planning-bulk-upload"))))]
                (set! (.-onload fr)
                  (fn [_]
                    (let [[header & rows] (csv/parse (.-result fr))]
                      (swap! action-atom assoc
                        :loading false
                        :header header
                        :file rows))))
                (swap! action-atom assoc :loading true)
                (.readAsText fr first-file))))
         :id "planning-bulk-upload"
         :name "planning-bulk-upload"}]

       (cond
         (cmn/curact action-atom :loading)
         [:span.dope-file-input__text
          [:span.dope-file-input__icon
           [:i.u-animate-spin {:class (u/bem :icon [:2-1 :loading :inline])}]]
          [:span {:class (u/bem :loading-text [:is-absolute])} "Uploading"]]

         :else
         [:span.dope-file-input__text
          [:span.dope-file-input__icon
           [:i
            {:class
             (cond
               loaded-file
               (u/bem :icon [:2-1 :document :block])

               :else
               (u/bem :icon [:2-1 :upload :block]))}]]
          [:span
           (cond
             loaded-file
             "Replace File"
             :else
             "Upload a file")]])]]

     [:div.form-hint-wrapper
      [:span.form-hint.js-form-hint
       (cond
         (nil? loaded-file)
         (str "Columns: SKU, then up to four monthly quantities. A column headed "
           "\"Cost\" sets a cost override for the line.")

         file-valid?
         (str "Ready to upload " (count loaded-file) " skus")

         :else
         "File Format Issue, please reupload and try again.")]]]))

(rum/defc commitment-file-upload < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)

        loaded-file (cmn/curact action-atom :file)
        header (cmn/curact action-atom :header)
        file-valid? (upload-valid? loaded-file header)

        loading? (cmn/curact action-atom :loading)
        commitment-date (cmn/curact action-atom :commitment-date)]
    [:div
     (toaster/loading-overlay app-atom :file-upload)
     (buttons/button-web "Back to Dashboard"
       (urlstate/href-props app-atom "planning-new" nil {}))
     (buttons/button-web "Try new layout"
        (merge
          (w.cmn/try-new-layout-props)
          {:style :light
           :size :default}))
     [:form {:name "commitment-order-upload" :action "" :method "GET" :target "_blank"}
      [:div
       {:class (u/bem :flex-grid-group [:flush])}
       [:div
        {:class (u/bem :flex-grid-block [:align-left :l-1-1])}
        [:div.flex-grid-content
         [:h2 "Commitment Order Upload"]]]

       [:div
        {:class (u/bem :flex-grid-block [:align-left :l-1-1])}
        (datepicker/datepicker app-atom "Commitment Order Date Start (Required)" "dd/mm/yy"
          [(cmn/curact app-atom [:page :screen]) :commitment-date]
          {:header "Filter by date and time" :time-picker false})]

       [:div
        {:class (u/bem :flex-grid-block [:align-left :l-1-1])}
        (file-upload app-atom)]

       [:div
        {:class (u/bem :flex-grid-block [:align-left :l-1-1])}
        (buttons/button-web "Submit"
          {:type :button
           :disabled
           (or
             loading?
             (not loaded-file)
             (not commitment-date)
             (not file-valid?))
           :on-click
           #(do
              (toaster/open-overlay app-atom :file-upload)
              (comms/ajax-post :planning.bulk/file-upload
                {:file
                 #?(:clj nil
                    :cljs (map js->clj loaded-file))
                 :header
                 #?(:clj nil
                    :cljs (js->clj header))
                 :commitment-date commitment-date}))

           :persistent true
           :flat-style :flat})]]]]))

(defmethod flow/render-screen :admin.planning-new/bulk [app-atom _]
  (planning.cmn/with-loading-overlay app-atom
    (cmn/permission-lock app-atom "SiteAdmin"
      (commitment-file-upload app-atom))))

(defmethod t/transition-open :admin.planning-new/bulk [app-atom _ params]
  (w.cmn/redirect-to-new-layout-if-needed! app-atom "planning" params))

(defmethod t/transition-after-open :admin.planning-new/bulk [app-atom _ _]
  (presence/open app-atom {:context/ident :stockorder.planning/bulk}))

(defmethod comms/receive :planning.bulk/file-upload [app-atom e]
  (toaster/close-overlay app-atom :file-upload)
  (toaster/open-toast app-atom :success (:msg e) {}))